import axios from 'axios';
import { Toast } from 'vant';
import authStore from '@/store/auth';

// 居中显示提示框的路径集合
const middleTostUrls = ['trainingcamp/enroll/'];

// 底部Toast提示
const bottomToast = (msg) => {
  const url = window.location.href;
  let msgPosition = 'bottom';
  middleTostUrls.forEach((item) => {
    if (url.indexOf(item) > -1) {
      msgPosition = 'middle';
    }
  });
  Toast({
    position: msgPosition,
    message: msg,
  });
};
const uploadRequest = axios.create({
  baseURL: process.env.VUE_APP_UPLOAD,
  withCredentials: true,
  timeout: 60000,
  headers: {
    post: {
      'Content-Type': 'application/json; charset=utf-8',
    },
  },
});

// 请求异常处理
const handleError = (error) => {
  console.log('%c [ error ]', 'font-size:13px; background:pink; color:#bf2c9f;', error);
  if (error.response) {
    const { status } = error.response;
    if (status >= 400 && status < 500) {
      bottomToast('网络异常，请稍后再试');
    } else {
      bottomToast('系统繁忙，请稍后再试');
    }
  } else if (error.msg.indexOf('timeout') !== -1) {
    bottomToast('请求超时，请稍后再试');
  } else {
    bottomToast('网络开小差了，请稍后再试');
  }
  return Promise.reject(error);
};

uploadRequest.interceptors.response.use(async (res) => {
  const {
    code, data, msg,
  } = res.data;
  switch (true) {
  case code === 200:
    return data;
  case code === 601: {
    const { config } = res;
    const { refreshToken } = authStore.state;
    if (!config.retried && refreshToken) {
      config.retried = true;
      const { accessToken } = await authStore.dispatch('refreshToken');
      config.headers.access_token = accessToken;
      return uploadRequest(config);
    }
    return Promise.resolve();
  }
  case code === 140011016:
    bottomToast(msg);
    return Promise.resolve();
  case code === 0:
    return data;
  case code === 14008001:
    bottomToast(msg);
    return Promise.reject(code);
  default:
    bottomToast(msg);
    return Promise.reject(res.data);
  }
}, handleError);

export default uploadRequest;

export {
  uploadRequest,
};
